import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DotsArrowRegularRight from './dots-arrow-regular-right-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DotsArrowRegularRight {...validProps} />;
}
SvgComponent.iconName = 'dotsArrowRegularRight';

export const DotsArrowRegularRightIcon = svgIconWrapper(SvgComponent);
